import { useSnackbar } from 'notistack';

let useSnackbarRef;
export const SnackbarConfigurator = () => {
    useSnackbarRef = useSnackbar();
    return null;
};

export const notify = (message, variant, options = {}) => {
    return useSnackbarRef.enqueueSnackbar(message, { variant, ...options });
};
